var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFactCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_343_17",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_343_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.58991 17.0833C3.16897 17.0833 2.81266 16.9375 2.521 16.6458C2.22933 16.3541 2.0835 15.9978 2.0835 15.5769V4.4231C2.0835 4.00216 2.22933 3.64585 2.521 3.35419C2.81266 3.06252 3.16897 2.91669 3.58991 2.91669H16.4104C16.8313 2.91669 17.1876 3.06252 17.4793 3.35419C17.771 3.64585 17.9168 4.00216 17.9168 4.4231V15.5769C17.9168 15.9978 17.771 16.3541 17.4793 16.6458C17.1876 16.9375 16.8313 17.0833 16.4104 17.0833H3.58991ZM3.58991 15.8333H16.4104C16.4745 15.8333 16.5333 15.8066 16.5867 15.7532C16.6401 15.6998 16.6668 15.641 16.6668 15.5769V4.4231C16.6668 4.35899 16.6401 4.30022 16.5867 4.24679C16.5333 4.19338 16.4745 4.16667 16.4104 4.16667H3.58991C3.5258 4.16667 3.46703 4.19338 3.4136 4.24679C3.36018 4.30022 3.33348 4.35899 3.33348 4.4231V15.5769C3.33348 15.641 3.36018 15.6998 3.4136 15.7532C3.46703 15.8066 3.5258 15.8333 3.58991 15.8333ZM4.37516 13.9583H8.12512V12.7084H4.37516V13.9583ZM12.1251 12.2035L15.9536 8.375L15.0626 7.484L12.1251 10.4423L10.9376 9.25483L10.0675 10.1458L12.1251 12.2035ZM4.37516 10.625H8.12512V9.37502H4.37516V10.625ZM4.37516 7.29165H8.12512V6.04169H4.37516V7.29165Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactCheck);
export default __webpack_public_path__ + "static/media/fact_check.6fdbabafbf76517f3e3e267887e67d7f.svg";
export { ForwardRef as ReactComponent };